import NewPasswordReducer from './NewPasswordReducer';

export default from './NewPasswordContainer';
export const NewPasswordReducers = {
  NewPasswordReducer,
};
